export const ReticleSignal = Object.freeze({
  AUTH_REGISTERED: 'auth:registered',
  AUTH_LOGGED_IN: 'auth:logged-in',
  CLINIC_CREATED: 'clinic:created',
  CLINIC_MEMBER_ADDED: 'clinic:member-added',
  PATIENT_CREATED: 'patient:created',
  APPOINTMENT_CREATED: 'appointment:created',
  APPOINTMENT_STATUS_UPDATED: 'appointment:status-updated',
  TEMPLATE_PUBLISHED: 'template:published',
  NOTE_CREATED: 'note:created',
  NOTE_UPDATED: 'note:updated',
  NOTE_DELETED: 'note:deleted',
  SYNC_IDLE: 'sync:idle',
});

export function signal(name, data = {}) {
  if (process.env.NODE_ENV === 'development') {
    if (process.env.REACT_APP_RETICLE_ENABLED === 'true') {
      void import('@reticlehq/react')
        .then(({ reticle }) => reticle.signal(name, data))
        .catch((error) => {
          console.warn('[reticle] signal emission failed:', error);
        });
    }
  }
}
